<template>
    <form>
        <b-form-row class="align-items-center">
            <b-col v-if="showIsPrimary">
                <b-check v-model="address && address.isPrimary" switch :disabled="shouldDisable">
                    Is Primary
                </b-check>
            </b-col>
            <b-col v-if="isPatientAddress">
                <EnumSelector v-model="address && address.type" :disabled="disableFields"
                    :enum-codes="PatientAddressType"/>
            </b-col>
        </b-form-row>
        <b-form-row>
            <b-col>
                <fg-input v-model="address && address.address1" label="Address" :disabled="shouldDisable"/>
            </b-col>
            <slot name="row-1"></slot>
        </b-form-row>
        <b-form-row>
            <b-col>
                <fg-input v-model="address && address.address2" label="Address 2" :disabled="shouldDisable"/>
            </b-col>
            <slot name="row-2"></slot>
        </b-form-row>
        <b-form-row v-if="!isPatientAddress">
            <b-col>
                <fg-input v-model="address && address.addressCity" label="City" type="text" :disabled="shouldDisable"/>
            </b-col>
            <b-col cols="3">
                <fg-select v-model="address && address.addressState" :options="stateOptions" :label="stateLabel" :disabled="shouldDisable"/>
            </b-col>
            <b-col cols="3">
                <fg-input v-model="address && address.addressZip" label="Zip" :disabled="shouldDisable" maxlength="10"/>
            </b-col>
            <slot name="row-3"></slot>
        </b-form-row>
        <b-form-row v-else>
            <b-col>
                <fg-input v-model="address && address.city" label="City" type="text" :disabled="shouldDisable"/>
            </b-col>
            <b-col cols="3">
                <fg-select v-model="address && address.state" :options="stateOptions" label="State"  :disabled="shouldDisable"/>
            </b-col>
            <b-col cols="3">
                <fg-input v-model="address && address.postalCode" label="Zip" :disabled="shouldDisable" maxlength="10"/>
            </b-col>
            <slot name="row-3"></slot>
        </b-form-row>
    </form>
</template>

<script lang="ts">
import HasAddress from '@/models/HasAddress';
import { PatientAddress, PatientAddressType } from '@/models/Patient';
import { Component, Vue, Prop } from 'vue-property-decorator';
import EnumSelector from './EnumSelector.vue';
import { ValidValues } from '@/data/ValidValues';

@Component({
    name: "AddressFormFields",
    components: {
        EnumSelector,
    },
})
export default class AddressFormFields extends Vue {
    @Prop({
        type: Boolean,
        default: false,
    }) private disableFields!: boolean;
    @Prop() private value!: HasAddress | PatientAddress;
    @Prop({ default: false }) private isPatientAddress!: boolean;
    @Prop({ default: false }) private showIsPrimary!: boolean;
    @Prop({ default: 'United States' }) private country!: string;

    PatientAddressType = PatientAddressType;

    get stateOptions() {
        if (this.country === 'Canada') {
            return ValidValues.addressProvinces;
        }
        return ValidValues.addressStates;
    }

    get stateLabel() {
        return this.country === 'Canada' ? 'Province' : 'State';
    }

    get shouldDisable(): boolean {
        return this.disableFields;
    }

    get shouldDisableTest(): boolean {
        return true;
    }

    get address(): any {
        return this.value;
    }

    set address(val: any) {
        this.$emit('input', val);
    }
}

</script>

<style scoped></style>
